import firebase from 'firebase/compat/app';

export const IS_STAGING = import.meta.env.VITE_IS_STAGING === 'true';
// eslint-disable-next-line no-console
console.log('IS_STAGING', IS_STAGING);

const firebaseConfigProd = {
  apiKey: 'AIzaSyAXM-XlUZwf7DoBSBq-pW_WF4OCZDOPDvw',
  authDomain: 'enkla-kassan.firebaseapp.com',
  databaseURL: 'https://enkla-kassan.firebaseio.com',
  projectId: 'enkla-kassan',
  storageBucket: 'enkla-kassan.appspot.com',
  messagingSenderId: '57452537691',
  appId: '1:57452537691:web:77e24f241d6abda9d7dc7e',
  measurementId: 'G-N2QC03N7KC',
};

const firebaseConfigStaging = {
  apiKey: 'AIzaSyDXR_wCYX78Zpjio2xOqJTAL8b2xS9dtAM',
  authDomain: 'enklakassan-staging.firebaseapp.com',
  projectId: 'enklakassan-staging',
  storageBucket: 'enklakassan-staging.appspot.com',
  messagingSenderId: '302380194563',
  appId: '1:302380194563:web:548d8f02451d09c2f7a736',
};

firebase.initializeApp(IS_STAGING ? firebaseConfigStaging : firebaseConfigProd);

// if (process.env.NODE_ENV === 'development') {
//   firebase.app().functions('europe-west1').useEmulator('localhost', 5002);
// }

const STAGING_URL = 'https://europe-west1-enklakassan-staging.cloudfunctions.net/api';

const PROD_URL = 'https://europe-west1-enkla-kassan.cloudfunctions.net/api';

let URL = IS_STAGING ? STAGING_URL : PROD_URL;

// For development only
if (import.meta.env.VITE_IS_LOCAL === 'true') {
  URL = 'http://localhost:5002/enkla-kassan/europe-west1/api';
  // URL = 'http://localhost:5002'
}

export const API_URL = URL;
